import React, { useEffect, useRef } from 'react';
import { Link } from 'gatsby';

const SingalVideo = ({ video, select_media,isFulWdith=false ,...props }) => {
    const gridRef = useRef(null);

    const handleHover = () => {
        const videoEl = gridRef.current?.querySelector('video');
        const imgEl = gridRef.current?.querySelector('img');
        const vdsrcMp4 = videoEl?.getAttribute('data-src-mp4');
        const isVideoUrl = videoEl.querySelector('source');
        //console.log(imgEl)

        if (videoEl && !isVideoUrl) {
            const sourceMp4 = document.createElement('source');
            sourceMp4.setAttribute('src', vdsrcMp4);
            sourceMp4.setAttribute('type', 'video/mp4');
            videoEl.appendChild(sourceMp4);
            // if (imgEl) {
            //     imgEl.style.display = 'none';
            // }
            videoEl.load(); // Ensure the video element is reloaded with the new source
            // if(videoEl.load()){
            //     videoEl.addEventListener('canplay', () => {
            //         videoEl.classList.add('video_loaded');
            //     }, { once: true });
            // }
            videoEl.currentTime = 0;
            videoEl.play().catch(err => console.error('Error playing video:', err));
        } else {
            // if (imgEl) {
            //     imgEl.style.display = 'none';
            // }
            videoEl.currentTime = 0;
            videoEl.play().catch(err => console.error('Error playing video:', err));
        }

        // videoEl.addEventListener('playing', () => {
        //     videoEl.classList.add('video_loaded');   
        // });

        videoEl.addEventListener('play', () => {
            const progressBar = videoEl.parentElement.querySelector('.progress-bar-inner');

            const updateProgressBar = () => {
                const progress = (videoEl.currentTime / videoEl.duration) * 100;
                progressBar.style.width = `${progress}%`;

                if (progress < 100) {
                    requestAnimationFrame(updateProgressBar);
                }
            };

            updateProgressBar();

            videoEl.addEventListener('ended', () => {
                videoEl.play().catch(err => console.error('Error replaying video:', err));
            });

            videoEl.addEventListener('pause', () => {
                progressBar.style.width = '0%';
            });

            videoEl.addEventListener('abort', () => {
                console.warn('Video loading was aborted');
            });
        });
    };

    const handleHoverOut = () => {
        const videoEl = gridRef.current?.querySelector('video');
        const progressBar = videoEl.parentElement.querySelector('.progress-bar-inner');
        videoEl.pause();
        progressBar.style.width = '0%';
        videoEl.currentTime = 0;
    };

    useEffect(() => {
        const handleIntersection = (entries) => {
            entries.forEach((entry) => {
                const imageEl = entry.target.querySelector('img');
                const imageUrl = imageEl.getAttribute('data-src');
                const isSrcExist = imageEl.getAttribute('src');
                const videoEl = entry.target.querySelector('video');
                const isVideoSrcExist = videoEl.querySelector('source');
                const vdsrcMp4 = videoEl?.getAttribute('data-src-mp4');
                const progressBar = videoEl.parentElement.querySelector('.progress-bar-inner');
                const isMobile = window.innerWidth <= 767;

                if (!isSrcExist) {
                    imageEl.setAttribute('src', imageUrl);
                    //videoEl.setAttribute('poster',imageUrl)
                }
                imageEl.addEventListener('load', () => {
                    // imageEl.style.display = 'none';
                    if (entry.isIntersecting && !isVideoSrcExist) {
                        const sourceMp4 = document.createElement('source');
                        
                        sourceMp4.setAttribute('src', vdsrcMp4);
                        sourceMp4.setAttribute('type', 'video/mp4');
                        videoEl.appendChild(sourceMp4);
                        videoEl.load(); // Ensure the video element is reloaded with the new source
                        videoEl.pause()
                    }
                })
                if (entry.isIntersecting && isMobile && videoEl && !videoEl.playing) {
                    //   videoEl.play().catch(err => console.error('Error playing video:', err));
                    // videoEl.playing = true;
                    videoEl.addEventListener('playing', () => {
                        videoEl.classList.add('loaded-foresp');

                        const updateProgressBar = () => {
                            const progress = (videoEl.currentTime / videoEl.duration) * 100;
                            progressBar.style.width = `${progress}%`;

                            if (progress < 100) {
                                requestAnimationFrame(updateProgressBar);
                            }
                        };

                        updateProgressBar();
                    });

                    videoEl.addEventListener('ended', () => {
                        progressBar.style.width = '0%';
                        videoEl.play().catch(err => console.error('Error replaying video:', err));
                    });
                } else if ((!entry.isIntersecting || !isMobile) && videoEl && (videoEl.playing || videoEl.currentTime > 0)) {
                    videoEl.pause();
                    videoEl.classList.remove('loaded-foresp');
                    videoEl.currentTime = 0;
                    videoEl.playing = false;
                    videoEl.addEventListener('pause', () => {
                        progressBar.style.width = '0%';
                    });
                }

                videoEl.addEventListener('abort', () => {
                    console.warn('Video loading was aborted');
                });
            });
        };

        const observerOptions = {
            root: null,
            rootMargin: '8px',
            threshold: 0.99,
        };
        const observer = new IntersectionObserver(handleIntersection, observerOptions);

        observer.observe(gridRef.current);

        return () => {
            observer.disconnect();
        };
    }, []);

   useEffect(() => {
    const loadVideoInBackground = () => {
    
        const videoEl = gridRef.current?.querySelector('video');
        if (!videoEl) return;

        const vdsrcMp4 = videoEl.getAttribute('data-src-mp4');
        const hasSource = videoEl.querySelector('source');

        if (!hasSource && vdsrcMp4) {
            const sourceMp4 = document.createElement('source');
            sourceMp4.setAttribute('src', vdsrcMp4);
            sourceMp4.setAttribute('type', 'video/mp4');
            videoEl.appendChild(sourceMp4);
            videoEl.load();
        }

        // ✅ Wait for the first frame to play, then pause and tag it
        const handlePlaying = () => {
            videoEl.pause();
            videoEl.currentTime = 0;
            videoEl.classList.add('video_loaded');
        };

        videoEl.addEventListener('playing', handlePlaying, { once: true });

        videoEl.addEventListener('abort', () => {
            console.warn('Video loading was aborted');
        });

        return () => {
            videoEl.removeEventListener('playing', handlePlaying);
        };
    };

    loadVideoInBackground();
}, []);

    const getFormattedAltText = (url) => {
        if (!url) return 'Image';
        const stopWords = ['for', 'by'];
        const parts = url.split('/');
        let filename = parts[parts.length - 1].split('.')[0];
      
        // Remove trailing hash if it's a 10+ character alphanumeric (e.g., UUID or hash)
        filename = filename.replace(/[-_]?([a-f0-9]{10,})$/i, '');
      
        return filename
          .replace(/[-_]/g, ' ')
          .trim()
          .split(' ')
          .map((word) => {
            return stopWords.includes(word.toLowerCase())
              ? word.toLowerCase()
              : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
          .join(' ');
      };
      

    return (
        <div className="anime-grid-item-row filterDiv web home-projects-grid-item relative">
            <div className="anime-grid-item-link" onMouseEnter={handleHover} onMouseLeave={handleHoverOut}>
                {isFulWdith?
                <div className="block img-wrapper min-h-[40.77vw] md:min-h-[38.77vw] xl:min-h-[499px]" ref={gridRef}>
                    <video data-src-mp4={video} preload="metadata" autoPlay muted playsInline {...props} style={{width:"100%"}}></video>
                    <img className="slide-thumb-img" data-src={select_media} loading="eager" alt={getFormattedAltText(select_media)} width="1160" height="499" />
                    <div className="progress-bar hidden" style={{ opacity: 0 }}>
                        <div className="progress-bar-inner"></div>
                    </div>
                </div>
                
                :<div className="block img-wrapper min-h-[46.317vw] md:min-h-[42.493vw] xl:min-h-[499px]" ref={gridRef}>
                    <video data-src-mp4={video} preload="metadata" autoPlay muted playsInline {...props} style={{width:"100%"}}></video>
                    <img className="slide-thumb-img" data-src={select_media} loading="eager" alt={getFormattedAltText(select_media)} width="500" height="499" />
                    <div className="progress-bar hidden" style={{ opacity: 0 }}>
                        <div className="progress-bar-inner"></div>
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default SingalVideo;
